import { castArray, compact } from 'lodash';
import { useMemo } from 'react';

import reddit_logo from './assets/reddit-logo.webp?file';

interface Post {
    author?: string;
    author_photo?: string;
    link: string;
    text: string;
}

interface EnhancedPost extends Post {
    author_photo_fallback?: string;
}

interface Social {
    reddit?: { posts: Post[] };
    twitter?: { tweets: Post[] };
}

export default function useSocialMediaPosts(social: Social) {
    const posts = useMemo(() => {
        const reddit: EnhancedPost[] = compact(castArray(social.reddit?.posts)).map((item) => ({
            ...item,
            author_photo: item.author_photo || reddit_logo,
            author_photo_fallback: reddit_logo
        }));

        const twitter: EnhancedPost[] = compact(castArray(social.twitter?.tweets));

        return [...reddit, ...twitter].map(({ text, link, author, author_photo, author_photo_fallback }) => ({
            link,
            text: text.replaceAll(/\/hashtag\/([A-Za-z0-9-_]+)\?src=hashtag_click/gi, (_, match) => `#${match}`),
            author: author || '',
            avatar: author_photo || '',
            avatarFallback: author_photo_fallback || ''
        }));
    }, [social]);

    return posts;
}
